import * as React from "react";
const SvgTempFrozen20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "black",
        viewBox: "0 0 20 20"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      d: "M9.167.833h1.666v2.56l2.113-2.113 1.179 1.178-3.292 3.292v2.807l2.431-1.404 1.205-4.496 1.61.431-.774 2.887 2.217-1.28.833 1.443-2.216 1.28 2.886.773-.431 1.61-4.496-1.204L11.667 10l2.43 1.403 4.497-1.204.431 1.61-2.886.773 2.216 1.28-.833 1.443-2.216-1.28.773 2.887-1.61.431-1.205-4.496-2.43-1.404v2.82l3.29 3.291-1.178 1.179-2.113-2.113v2.547H9.167V16.62l-2.113 2.113-1.179-1.179 3.292-3.291v-2.82l-2.442 1.41L5.52 17.35l-1.61-.43.774-2.887-2.206 1.273-.833-1.443 2.205-1.274-2.886-.773.431-1.61 4.497 1.205L8.333 10 5.892 8.59 1.395 9.795l-.431-1.61 2.886-.773-2.205-1.274.833-1.443 2.206 1.273-.774-2.886 1.61-.431 1.205 4.496 2.442 1.41V5.75L5.875 2.458 7.054 1.28l2.113 2.113V.833Z"
    })
  );
export default SvgTempFrozen20Px;
